import { Decimal } from 'decimal.js';
import { ElMessage } from 'element-plus';
import { messages } from '~/i18n.config';
import config from '../config/index';
import { get } from 'lodash-es';
/**
 * 转换rem单位
 
 * @returns {*}
 */

export function toRem(num = 0) {
  return num / getRemRate() + "rem";
}

export function getRemRate() {
  return 10;
}

export function setRemHtml() {
  let setFontSize =
    parseInt((document.documentElement.clientWidth / 375) * getRemRate() * 10) /
    10;
  setFontSize = setFontSize < 10 ? 10 : setFontSize;
  setFontSize = setFontSize > 20 ? 20 : setFontSize;
  document.getElementsByTagName("html")[0].style =
    "font-size:" + setFontSize + "px";
}

export function isQiankunPage(path) {
  return   path.indexOf("/sub") >= 0 && path.indexOf("/sub/login")<0;
}

/**
 * file转base64
 * @param { * } file 图片文件
 * @return {base64}
 */
export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function (e) {
      resolve(e.target.result)
      return e.target.result;
    };
  });
};

export function findBaseData(imgUrl, fileName) {
  return new Promise((resolve, reject) => {
    var img = new Image();
    img.setAttribute("crossOrigin", "anonymous");
    img.src = imgUrl;
    setTimeout(() => {}, 1000);
    img.onload = () => {
     // console.log("onload," + imgUrl);
      let resData = "data:,";
      let canvas = document.createElement("canvas");
      let canvas2d = canvas.getContext("2d");
      canvas.height = img.height;
      canvas.width = img.width;
      canvas2d.drawImage(img, 0, 0);
      resData = canvas.toDataURL(`image/${fileName.split(".").pop()}`);
      canvas.remove();
      img.remove();
      resolve(resData);
    };
    img.onerror = function () {
      reject("图片加载错误");
      // 在这里处理加载失败的情况
    };
  });
}

export function findBaseDataFn(img, fileName) {
  if (!fileName) fileName = img.split("/").pop();
  return new Promise((resolve, reject) => {
    let timer = null;
    let total = 0;
    findBaseData(img, fileName).then((findData) => {
      if (findData == "data:,") {
        timer = setInterval(() => {
          findBaseData(img, fileName).then((findData) => {
            if (findData != "data:,") {
              clearInterval(timer);
              resolve(findData);
            } else if (total > 10) {
              clearInterval(timer);
              reject("查找不到base64数据");
            }
          });
        }, 500);
      } else {
        resolve(findData);
      }
    });
  });
}

export function compressBase64Image(
  base64Image,
  maxWidth,
  maxHeight,
  maxSizeKB,
  quality = 0.7
) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = base64Image;

    img.onload = function () {
      const width = img.width;
      const height = img.height;

      // 创建 Canvas 对象
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      // 设置压缩比率
      const ratio = Math.min(maxWidth / width, maxHeight / height);
      const newWidth = width * ratio;
      const newHeight = height * ratio;

      canvas.width = newWidth;
      canvas.height = newHeight;

      // 绘制图片到 canvas
      ctx.drawImage(img, 0, 0, newWidth, newHeight);

      // 将 canvas 转换为 Base64 字符串并检查大小
      const compressedBase64 = canvas.toDataURL("image/jpeg", quality);

      // 获取 Base64 字符串的大小（单位为 KB）
      const imageSizeKB = (compressedBase64.length * 3) / 4 / 1024;

      // 如果图片超出了最大文件大小，则继续压缩，直到满足大小限制
      if (imageSizeKB > maxSizeKB) {
        // 逐步减少质量直到图片大小符合要求
        const newQuality = Math.max(0.1, quality - 0.1);
        if (newQuality < 0.1) {
          reject("无法压缩至目标大小");
        } else {
          resolve(
            compressBase64Image(
              base64Image,
              maxWidth,
              maxHeight,
              maxSizeKB,
              newQuality
            )
          );
        }
      } else {
        resolve(compressedBase64); // 返回压缩后的 Base64 图片
      }
    };

    img.onerror = function (error) {
      reject(error);
    };
  });
}



export function $t(key, params = {}) {
 
  let locale = config.defaultLocale;
  try {
    if (typeof useNuxtApp === 'function') {
      const { $i18n } = useNuxtApp();
      if ($i18n && $i18n.locale) {
        locale = typeof $i18n.locale === 'function' ? $i18n.locale() : $i18n.locale.value;
      }
    }
  } catch (e) {}

  // 支持嵌套 key，如 'placeholder.pleaseSelected{text}'
 
  let str = get(messages[locale],key);
  if (typeof str !== 'string') str = key;

  // 替换参数
  if (str && params && typeof params === 'object') {
    Object.keys(params).forEach(k => {
      str = str.replace(new RegExp(`{${k}}`, 'g'), params[k]);
    });
  }
 
  return str;
}

 // 乘法计算
 export const multiplication = (value, end) => {
  value = (value === null || value === undefined || value === '') ? 0 : value;
  end = (end === null || end === undefined || end === '') ? 0 : end;
  const vlu = new Decimal(value).mul(new Decimal(end)).toNumber();
  return vlu;
};



export const copyText = (text, hintInfor = "复制,成功!") => {
  let container = document.getElementsByClassName("copyText-container")[0];
  if (!container) {
    const copyInput = document.createElement("textarea");
    copyInput.className = "copyText-container";
    document.body.appendChild(copyInput);
    container = copyInput;
  }
  container.value = "";
  container.value = text;
  container.select(); // 选择对象
  document.execCommand("Copy"); // 执行浏览器复制命令
  if (hintInfor) {
    ElMessage({
      type: "success",
      message: hintInfor,
    });
  }
};

export const transferOssUrl = (url, width = 200) => {
  if (!url || typeof url !== "string") return url || "";

  const lower = url.toLowerCase();
  // dataURL、base64、blob、本地文件等不处理
  if (
    lower.startsWith("data:") ||
    lower.startsWith("blob:") ||
    lower.startsWith("file:")
  ) {
    return url;
  }

  // 已经处理过的直接返回
  if (url.includes("x-oss-process=")) {
    return url;
  }

  const processStr = `x-oss-process=image/resize,w_${width}`;

  // 已有其它 query 参数
  if (url.includes("?")) {
    // 如果以 ? 或 & 结尾，直接拼接
    if (/[?&]$/.test(url)) {
      return `${url}${processStr}`;
    }
    return `${url}&${processStr}`;
  }

  // 没有任何 query
  return `${url}?${processStr}`;
};
